<script>
export default {
	name: 'FlightSearch',
	inheritAttrs: false,
};
</script>

<script setup>
import OverlayBonusSideTrip from '~/components/BookingWidget/BonusSideTrip/OverlayBonusSideTrip.vue';
import MobileSubpage from '~/components/BookingWidget/MobileSubpage.vue';
import useBookingWidgetSubpage from '~/logic/composables/useBookingWidgetSubpage.js';
import VueTabs from '~/components/VueTabs.vue';
import SubTabBookFlight from '~/components/BookingWidget/FlightSearch/SubTabBookFlight.vue';
import SubTabMultiCity from '~/components/BookingWidget/FlightSearch/SubTabMultiCity.vue';
import SubTabBonusSideTrip from '~/components/BookingWidget/FlightSearch/SubTabBonusSideTrip.vue';
import SubTabTermsConditions from '~/components/BookingWidget/FlightSearch/SubTabTermsConditions.vue';
import ContinueYourSearch from '~/components/BookingWidget/FlightSearch/ContinueYourSearch.vue';
import usePersistencyWithExpiry from '~/logic/composables/usePersistencyWithExpiry.js';
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';
import { onClickOutside, useEventBus } from '@vueuse/core';
import { gsap } from 'gsap';
import { getAncestorBySelector } from '~/logic/helpers/dom.js';
import { isMobileViewport, isLG } from '~/logic/composables/breakpoints.js';
import { useBSTOverlayInterimData } from '~composables/booking-widget/useBSTOverlayInterimData.js';
import { isUrlMatchCurrentHostname } from '~/logic/helpers/string.js';
import { pushAA_flightSearchStart, pushAA_flightSearchEnd, pushAA_click } from '~/logic/adobe-analytic.js';
import { useHeaderScroll } from '~/logic/composables/useHeaderScroll.js';
import { sleep } from '~/logic/helpers/utils.js';
import { useBookingWidgetUrlQuery } from '~/logic/composables/booking-widget/useBookingWidgetUrlQuery.js';
import { useAuthStore } from '~/logic/auth/auth-store.js';
import SubTabRedeemFlight from '~/components/BookingWidget/FlightSearch/SubTabRedeemFlight.vue';
import AppHyperlink from '~/components/AppHyperlink.vue';
import { useRoute } from 'vue-router';
import Tooltip from '~/components/Tooltip.vue';
import { watchEffect } from 'vue';
import dayjs from 'dayjs';
import MobileSubPageSwiper from '~/components/BookingWidget/MobileSubPageSwiper.vue';
import { getCookie } from '~/logic/helpers/cookies.js';

const props = defineProps({
	// modelValue: { type: String, default: '' },
	bonusSideTrip: { type: Object, default: null },
	bookFlight: { type: Object, default: null },
	termsAndConditionsTab: { type: Object, default: null },
	labels: { type: Object, default: null },
	mobileAddOns: { type: Object, default: null },
	multiCity: { type: Object, default: null },
	isInBookingWidget: { type: Boolean, default: false },
	flightSearchApiUrl: { type: String, default: '' },
	cabinClassCashList: { type: Array, default: () => [] },
	cabinClassMilesList: { type: Array, default: () => [] },
	componentIdAA: { type: String, default: '' },
	togglePointsApiURL: { type: String, default: '' },
	signUpApiUrl: { type: String, default: '' },
	countryVariants: { type: Array, default: () => [] },
	redeemFlight: { type: Object, default: null },
	redeemFlightOW: { type: Object, default: null },
	dspBookingRedirector: { type: Object, default: null },
	dspBookingApiUrl: { type: String, default: '' },
	// Props to hide on other page than homepage.
	isHideContinueYourSearchSection: { type: Boolean, default: false },

	enrichAlwaysOnCountriesData: { type: Array, default: () => [] },
	cabinClassMilesOWList: { type: Array, default: () => [] },
	mobileSwiperTabs: { type: Array, default: () => [] },
	
});

const emit = defineEmits([
	'update:active-sub-tab',
]);

const rootEl = ref(null);
const subTabBookFlightEl = ref(null);
const subTabRedeemFlightEl = ref(null);
const subTabBonusSideTripEl = ref(null);
const vueTabsComponent = ref(null);
const isEnrichPortal = (window.siteName === 'enrich-portal');
const route = useRoute();
const cidValue = ref(null);
const isLoading = ref(false);
const isPromoEditorEnabled = ref(false);
const promoInputRef = ref(false);

const promoCode = ref(props?.bookFlight?.promoCode?.promoCodeLabelPH ?? null);

const isEdgePaddingApplied = ref(false);
const { isMobileSubpageVisible } = useBookingWidgetSubpage({
	hashKey: ['flight-search', 'flight-search-tab'],
	rootEl,
});

const { isEditorMode, bookingWidgetSubTab } = useGlobalAEMState();

const activeSubTab = ref('book-flight');
const activeSubTabPreStick = ref('book-flight');
const isSticked = ref(false);
const expressBooking = ref(false);
const mblExpressBooking = ref(false);
const subPageMblExpressBooking = ref(false);
const isExpressBookingDisabled = ref(false);
const isONDSelected = ref(false);
const bookingWidgetSubPageVisible = ref(false);
const mobileProperties = ref(null);

onMounted(() => {
	const switchTabContent = getAncestorBySelector(rootEl.value, '.SwitchTabContent');
	onClickOutside(switchTabContent?.[0], (event) => {
		if (isSticked.value) stickyCollapse();
	});
	if (route.query?.cid) {
		cidValue.value = route.query.cid;
		route.query.cid = decodeURI(route.query.cid);
		document.cookie = `portalfacts_cid=${ route.query.cid }`;
	}
	mobileProperties.value = getCookie('mobileProperties');
});

const handleRootFocusWithin = () => {
	if (isSticked.value) stickyExpand();
};
const handleRootBlurWithin = () => {
	//
};

const pastSearches = ref([]);
const showLoginNote = ref(false);
const bookingWidgetBus = useEventBus('booking-widget');

const {
	isLoggedIn,
	isSapphireCookiePresent,
} = useAuthStore();

bookingWidgetBus.on((event, payload) => {
	switch (event) {
		case 'sticky:sticked': {
			isSticked.value = true;
			handleOnStick(payload);
			break;
		}
		case 'sticky:unsticked': {
			isSticked.value = false;
			handleOnUnstick(payload);
			break;
		}
		case 'booking-widget-ond-selected': {
			bookingWidgetSubPageVisible.value = true;
			console.log(bookingWidgetSubPageVisible);
			
			break;
		}
		default: {
			// console.log(`Unknown event: "${event}". Ignoring it.`);
			break;
		}
	}
});


const handleOnStick = async (payload) => {
	// console.log('handleOnStick');
	activeSubTabPreStick.value = activeSubTab.value;

	// const beforeStickHeight = payload.triggerEl.offsetHeight;
	payload.resizeObserver.unobserve(payload.triggerEl);
	// debugger;
	// payload.rootEl.value.style.setProperty('--pinSpacingHeight', `${beforeStickHeight}px`);

	stickyCollapse({ skipAnimation: true });
	/*
	const beforeStickHeight = payload.triggerEl.offsetHeight;

	stickyCollapse({ skipAnimation: false });

	const pinSpacerEl = payload.rootEl.value.querySelector('.pin-spacer');
	const afterStickHeight = 112;
	pinSpacerEl.__beforeStickHeight = beforeStickHeight;

	gsap.fromTo(pinSpacerEl, {
		height: beforeStickHeight,
	}, {
		height: afterStickHeight + 120,
		duration: 0.35,
		overwrite: true,
	}); */

	/* const pinSpacerEl = payload.rootEl.value.querySelector('.pin-spacer');

	gsap.to(pinSpacerEl, {
		height: 112 + 120,
		duration: 0,
		overwrite: true,
	}); */

	const { paused: headerScrollPaused } = useHeaderScroll();


	/* headerScrollPaused.value = true;
	const pinSpacerEl = payload.rootEl.value.querySelector('.pin-spacer');
	gsap.to(pinSpacerEl, {
		height: beforeStickHeight,
		// duration: 0.3,
		duration: 0,
		overwrite: true,
		onComplete: () => {
			headerScrollPaused.value = false;
		},
	}); */

	headerScrollPaused.value = true;

	// debugger;
	await sleep(200);
	payload.triggerEl.classList.remove('pre-stick');

	gsap.fromTo(payload.triggerEl, {
		y: '-100%',
	}, {
		y: 0,
		duration: 0.3,
		overwrite: true,
		onComplete: () => {
			headerScrollPaused.value = false;
		},
	});
};
const handleOnUnstick = async (payload) => {
	// console.log('handleOnUnstick');
	activeSubTab.value = activeSubTabPreStick.value;
	stickyExpand({ skipAnimation: true });

	/* stickyExpand({ skipAnimation: false });

	const pinSpacerEl = payload.rootEl.value.querySelector('.pin-spacer');

	gsap.to(pinSpacerEl, {
		height: pinSpacerEl.__beforeStickHeight,
		duration: 0.35,
		overwrite: true,
		onComplete: () => {
			payload.scrollTriggerInstance.refresh();
		},
	}); */
	// payload.scrollTriggerInstance.refresh();
	// await nextTick();
	// payload.scrollTriggerInstance.refresh();
	await nextTick();
	// payload.triggerEl.classList.remove('pre-stick');
	await sleep(200);

	payload.resizeObserver.observe(payload.triggerEl);
};
const stickyExpand = ({ skipAnimation = false } = {}) => {
	// console.log('stickyExpand');
	const tabRootEl = rootEl.value.querySelector('.VueTabs');
	const expandableWrapperEL = tabRootEl.querySelector('.SubTabBookFlight .TransitionHeight');
	const continueYourSearchEl = rootEl.value.querySelector('.continue-your-search-container');

	gsap.to(expandableWrapperEL, {
		duration: skipAnimation ? 0 : 0.2,
		height: 'auto',
		onComplete: () => {
			gsap.set(expandableWrapperEL, {
				overflow: 'visible',
			});
		},
		overwrite: true,
	});

	if (continueYourSearchEl) {
		gsap.to(continueYourSearchEl, {
			duration: skipAnimation ? 0 : 0.2,
			height: 'auto',
			overwrite: true,
		});
	}
	gsap.to(tabRootEl, {
		duration: skipAnimation ? 0 : 0.2,
		marginTop: 0,
		overwrite: true,
	});
};
const stickyCollapse = async ({ skipAnimation = false } = {}) => {
	// console.log('stickyCollapse');
	const CONTAINER_PADDING_TOP = 32;
	const tabRootEl = rootEl.value.querySelector('.VueTabs');
	const tabSwiperEl = tabRootEl.querySelector('.VueTabs .VueSwiper');
	const TAB_HEIGHT = tabSwiperEl.offsetHeight;
	const OFFSET_TOP = CONTAINER_PADDING_TOP + TAB_HEIGHT;
	const expandableWrapperEL = tabRootEl.querySelector('.SubTabBookFlight .TransitionHeight');
	const continueYourSearchEl = rootEl.value.querySelector('.continue-your-search-container');

	activeSubTab.value = 'book-flight';

	gsap.set(expandableWrapperEL, {
		overflow: 'hidden',
	});
	gsap.to(expandableWrapperEL, {
		duration: skipAnimation ? 0 : 0.2,
		height: 0,
		overwrite: true,
	});
	if (continueYourSearchEl) {
		gsap.to(continueYourSearchEl, {
			duration: skipAnimation ? 0 : 0.2,
			height: 0,
			overwrite: true,
		});
	}

	gsap.to(tabRootEl, {
		duration: skipAnimation ? 0 : 0.2,
		marginTop: `-${OFFSET_TOP}`,
		overwrite: true,
	});
};


const continueYourSearchComponent = ref(null);

const handleSaveSearchData = (data) => {
	continueYourSearchComponent.value?.saveSearch(data);
};

const restorePastSearch = async (searchData) => {
	// mobile subpage is not required for enrich
	if (isMobileViewport.value && !isEnrichPortal && !props.labels?.enableGlassDesign) {
		// activate the tab...
		isMobileSubpageVisible.value = true;
		await nextTick();
	}

	if (searchData.isBSTTab) {
		activeSubTab.value = 'bonus-side-trip';
		await nextTick();
		vueTabsComponent.value.scrollToTab('bonus-side-trip');
		subTabBonusSideTripEl.value.restorePastSearch(searchData);
	} else if (searchData.payByEnrichPoints) {
		activeSubTab.value = 'redeem-flight';
		await nextTick();
		vueTabsComponent.value.scrollToTab('redeem-flight');
		subTabRedeemFlightEl.value.restorePastSearch(searchData);
		subTabRedeemFlightEl.value.isExpanded = true;
	} else {
		activeSubTab.value = 'book-flight';
		await nextTick();
		vueTabsComponent.value.scrollToTab('book-flight');
		subTabBookFlightEl.value.restorePastSearch(searchData);
		subTabBookFlightEl.value.isExpanded = true;
	}
};

const isBSTOverlayVisible = ref(false);

const { commitDataToBSTOverlay } = useBSTOverlayInterimData();

const handleShowBSTOverlay = () => {
	isBSTOverlayVisible.value = true;
};

const handleFillUpForm = async (payload) => {
	if (isMobileViewport.value) {
		isMobileSubpageVisible.value = true;
		await nextTick();
	}

	activeSubTab.value = 'book-flight';
	activeSubTabPreStick.value = 'book-flight';
	await nextTick();
	vueTabsComponent.value.scrollToTab('book-flight');
	subTabBookFlightEl.value.updateLocationFromTo(payload);
};


const globalBookFlightBus = useEventBus('booking-widget:book-flight');

globalBookFlightBus.on(async (event, payload) => {
	switch (event) {
		case 'active-tab-and-fill-up-form':
			handleFillUpForm(payload);
			await nextTick();
			break;
		default:
			console.log(`Unknown event: ${event}. Ignore it.`);
			break;
	}
});

const globalBookFlightWidgetBus = useEventBus('booking-widget:enrich-points-toggle-switch');
globalBookFlightWidgetBus.on(async (event, status) => {
	switch (event) {
		case 'update-toggle-switch':
			if (status === 'logout') {
				activeSubTab.value = 'book-flight';
				emit('update:active-sub-tab', 'book-flight');
			}
			
			await nextTick();
			break;
		default:
			console.log(`Unknown event: ${event}. Ignore it.`);
			break;
	}
});

const showPromoCodeBus = useEventBus('booking-widgwet:show-promo-code-field');
const detectPromoCode = useEventBus('booking-widgwet:promo-code');

detectPromoCode.on(async (event, data) => {
	switch (event) {
		case 'detect-promo-code':
			if (data.promoCode) {
				promoCode.value = data.promoCode.value;
			}
			break;
		default:
			console.log(`Unknown event: ${event}. Ignore it.`);
			break;
	}
});

//  AA for sub tab click tracking
watch(activeSubTab, (newTabName) => {
	pushAA_click([
		{
			clickName: newTabName,
			clickComponentType: 'Button',
			componentName: 'FlightSearch',
			componentID: props.componentIdAA,
		},
		{
			name: newTabName,
			type: 'other',
		},
	]);
});

watchEffect(() => {
	if (bookingWidgetSubTab.value !== null && bookingWidgetSubTab.value !== activeSubTab.value) {
		activeSubTab.value = bookingWidgetSubTab.value;
		emit('update:active-sub-tab', bookingWidgetSubTab.value);
	}
});

let AAHasSentStart = false;
let AAHasSentEnd = false;

const handleShowPromoCode = () => {
	showPromoCodeBus.emit({ open: true });
};

const detectEdgeBrowser = () => {
	if (!props.bookFlight?.general?.subHeaderTabTooltipLabel) {
		const isEdge = navigator.userAgent.includes('Edg/');
		const stickyElement = document.querySelector('.SwitchTabContent')?.classList.contains('sticked');
		isEdgePaddingApplied.value = isEdge && stickyElement;
	}
};

const handleShowLoginNote = (event) => {
	if (event.isEmpty) {
		showLoginNote.value = false;
	}
};

watch(isONDSelected, (newValue) => {
	if (isONDSelected.value) {
		isExpressBookingDisabled.value = true;
	} else {
		isExpressBookingDisabled.value = false;
	}
});

const handleExpressBookingDisabled = (event = false) => {
	if (isONDSelected.value) {
		if (event) {
			isExpressBookingDisabled.value = false;
		} else {
			isExpressBookingDisabled.value = true;
		}
	} else {
		isExpressBookingDisabled.value = false;
	}
		
};
const blendedHeaderCss = ref('');
onMounted(() => {
	const aaFormStartHandler = (event) => {
		if (AAHasSentStart) return;
		if (event.target.tagName === 'FORM') return;

		AAHasSentStart = true;
		// pushAA_flightSearchStart(activeSubTab.value);
		rootEl.value.removeEventListener('focus', aaFormStartHandler, { capture: true });
	};
	rootEl.value.addEventListener('focus', aaFormStartHandler, { capture: true });
	window.addEventListener('scroll', detectEdgeBrowser, { passive: true });
	usePersistencyWithExpiry('flight-search:past-searches', {
		refs: {
			pastSearches,
		},
	});
	if (pastSearches.value?.length !== 0) {
		showLoginNote.value = true;
	}

	const header = document.querySelector('.global-header');
	if (!header) return;
	if (header.classList.contains('fixed')) {
		blendedHeaderCss.value = 'blended-header-css';
	} else {
		blendedHeaderCss.value = '';
	}
});

onUnmounted(() => {
	window.removeEventListener('scroll', detectEdgeBrowser);
});

const triggerFlightStartEvent = () => {
	pushAA_flightSearchStart(activeSubTab.value);
};

const sendFormCompleteAA = (subtabName, searchData) => {
	if (AAHasSentEnd) return;
	AAHasSentEnd = true;
	let passengerString = '';
	let searchObj = {};
	if (subtabName === 'multi-city') {
		const depDate1 = dayjs(searchData?.departDate1, 'YYYYMMDDHHmm').format('YYYY-MM-DD');
		const depDate2 = dayjs(searchData?.departDate2, 'YYYYMMDDHHmm').format('YYYY-MM-DD');
		passengerString = `
		tot:${(searchData?.passengerAdults ?? 0) +
			(searchData?.passengerChildren ?? 0) +
			(searchData?.passengerTeens ?? 0) +
		(searchData?.passengerInfants ?? 0)}/
		adt:${searchData?.passengerAdults ?? 0}/
		chd:${searchData?.passengerChildren ?? 0}/
		inf:${searchData?.passengerInfants ?? 0}/
		c15:${searchData?.passengerTeens ?? 0}`;

		searchObj = [
			{ 'key': 'origin1', 'value': searchData?.originAirportCode1 },
			{ 'key': 'origin2', 'value': searchData?.originAirportCode2 },
			{ 'key': 'destination1', 'value': searchData?.destAirportCode1 },
			{ 'key': 'destination2', 'value': searchData?.destAirportCode2 },
			{ 'key': 'departure-date1', 'value': depDate1 },
			{ 'key': 'departure-date2', 'value': depDate2 },
			{ 'key': 'return-date', 'value': '' },
			{ 'key': 'promocode', 'value': searchData?.promoCode ? searchData.promoCode : 'none' },
			{ 'key': 'travel-group', 'value': passengerString.trim().replace(/\s+/g, '') },
		];
	} else {
		passengerString = `
		tot:${(searchData?.adultsCount ?? 0) +
			(searchData?.childrenCount ?? 0) +
			(searchData?.teensCount ?? 0) +
		(searchData?.infantsCount ?? 0)}/
		adt:${searchData?.adultsCount ?? 0}/
		chd:${searchData?.childrenCount ?? 0}/
		inf:${searchData?.infantsCount ?? 0}/
		c15:${searchData?.teensCount ?? 0}`;
		searchObj = [
			{ 'key': 'origin', 'value': searchData?.ondValueFrom.value },
			{ 'key': 'destination', 'value': searchData?.ondValueTo.value },
			{ 'key': 'departure-date', 'value': searchData?.dateRangeValueFrom },
			{ 'key': 'return-date', 'value': searchData?.dateRangeValueTo },
			{ 'key': 'promocode', 'value': searchData?.promoCodeValue ? searchData.promoCodeValue : 'none' },
			{ 'key': 'travel-group', 'value': passengerString.trim().replace(/\s+/g, '') },
		];
	}
	if (subtabName === 'redeem-flight') {
		const activeSubTabName = `${subtabName}-${searchData.activeOption}`;
		pushAA_flightSearchEnd(activeSubTabName, searchObj);
	} else {
		pushAA_flightSearchEnd(subtabName, searchObj);
	}
};

const shouldRedirectToLogin = (subtab) => {
	return (subtab === 'redeem-flight' && !isSapphireCookiePresent());
};

const handleExpressBookingStatus = (status) => {
	expressBooking.value = status;
	if (isMobileViewport.value || isLG) {
		mblExpressBooking.value = status;
		subPageMblExpressBooking.value = status;
	}
};

const handleQueryChange = (query) => {
	if (!query) return;
	if (isMobileViewport.value && query.fromHistogram !== 'true') {
		isMobileSubpageVisible.value = true;
	}
	const newSubTab = query.subtab ?? '';
	if (newSubTab) {
		activeSubTab.value = newSubTab;
		emit('update:active-sub-tab', newSubTab);
	}
};

const setupTabWatcher = (mainTabName) => {
	const { registerQueryChange } = useBookingWidgetUrlQuery({ mainTabName });
	registerQueryChange(handleQueryChange);
};

setupTabWatcher('flight-search-tab');
setupTabWatcher('enrich-flight-search');

const tabClickHandler = async ($event) => {
	if (props.bookFlight?.general?.enableGlassDesign && isMobileViewport.value) {
		bookingWidgetSubTab.value = $event;
		bookingWidgetBus.emit('sub-tab-selected', $event);
	}
	if (props.bookFlight?.general?.isExpandOriginDropdownOnClickTab && $event === 'book-flight') {
		await nextTick();
		subTabBookFlightEl.value.openFromONDPicker();
	}
};

const enablePromocodeEditor = async (status) => {
	isPromoEditorEnabled.value = status;
	await nextTick();
	promoInputRef.value?.focus();
};

const resetPromoCode = () => {
	promoCode.value = null;
	isPromoEditorEnabled.value = false;
};

</script>

<template>
<div
	ref="rootEl"
	v-focus-within
	class="FlightSearch booking-widget-subcomponent"
	tabindex="-1"
	:class="{
		'isEditorMode': isEditorMode,
	}"
	@focus-within="handleRootFocusWithin"
	@blur-within="handleRootBlurWithin"
>
	<div class="generic-container">
		<h5 v-if="isEditorMode" class="title-editor-mode">
			<icon-fas-plane class="mr-2 fill-current inline-block" />
			<span>Booking Widget: Flight Search</span>
		</h5>
		<VueTabs
			ref="vueTabsComponent"
			v-model="activeSubTab"
			:dormantMode="isEditorMode"
			renderPanelsWithVShow
			:enableGlassDesign="props.labels?.enableGlassDesign"
			@update:modelValue="$emit('update:active-sub-tab', $event)"
			@tab-click="tabClickHandler"
		>
			<template v-if="!props.bookFlight?.general?.isHideInDesktop && props.labels?.flightType?.bookFlightLabel" #tab-book-flight>
				<div class="flex items-center justify-center p-4">
					<span class="inline-block ml-1">{{ props.labels?.flightType?.bookFlightLabel }}</span>
				</div>
			</template>
			<template v-if="!props.multiCity?.general?.isHideInDesktop && props.labels?.flightType?.multiCityLabel" #tab-multi-city>
				<div class="flex items-center justify-center p-4">
					<span class="inline-block ml-1">{{ props.labels?.flightType?.multiCityLabel }}</span>
				</div>
			</template>
			<template v-if="!props.labels?.flightType?.isHideInDesktopRedeemFlight && props.labels?.flightType?.redeemFlightLabel" #tab-redeem-flight>
				<div class="flex items-center justify-center p-4">
					<span class="inline-block ml-1">{{ props.labels?.flightType?.redeemFlightLabel }}</span>
				</div>
			</template>
			<template v-if="!props.labels?.flightType?.isHideInDesktop && props.labels?.flightType?.roundTheWorldLabel" #link-round-the-world>
				<AppHyperlink
					v-aa="[
						{
							clickName: props.labels?.flightType?.roundTheWorldLabel,
							clickComponentType: 'Button',
							componentName: 'FlightSearch',
							componentID: props.componentIdAA,
						},
						{
							name: props.labels?.flightType?.roundTheWorldLabel,
							type: isUrlMatchCurrentHostname(props.url) ? 'other' : 'exit',
						},
					]"
					:href="props.labels?.flightType?.roundTheWorldURL"
					class="font-semibold text-$text-color rounded-xl px-4 hover:bg-neutral-grey-extralight h-full leading-none"
					:target="props.labels?.flightType?.openInNewTab ? '_blank' : '_self'"
					:autoExternalLinkIcon="true"
				>{{ props.labels?.flightType?.roundTheWorldLabel }}</AppHyperlink>
			</template>
			<template v-if="!props.bonusSideTrip?.general?.isHideInDesktop && props.labels?.flightType?.bonusSideTripLabel" #tab-bonus-side-trip>
				<div class="flex items-center justify-center p-4">
					<span class="inline-block ml-1">{{ props.labels?.flightType?.bonusSideTripLabel }}</span>
				</div>
			</template>
			<template v-if="!props.termsAndConditionsTab?.general?.isHideInDesktop && props.termsAndConditionsTab?.showTandCTab" #tab-terms-and-conditions>
				<div class="flex items-center justify-center p-4">
					<span class="inline-block ml-1">{{ props.termsAndConditionsTab?.termsAndConditionsLabel }}</span>
				</div>
			</template>

			<div
				v-if="!props.bookFlight?.general?.isHideInDesktop"
				identifier="book-flight"
			>
				<!-- if edge browsser then remove padding -->
				<SubTabBookFlight
					ref="subTabBookFlightEl"
					:class="{ 'pt-6': !isEdgePaddingApplied }"
					:hideTodayDateIndicator="props.labels?.paymentType?.hideTodayDateIndicator"
					:subHeaderTabDescription="props.bookFlight?.general?.subHeaderTabDescription"
					:subHeaderTabTooltipBody="props.bookFlight?.general?.subHeaderTabTooltipBody"
					:subHeaderTabTooltipLabel="props.bookFlight?.general?.subHeaderTabTooltipLabel"
					:topNote="props.bookFlight?.general?.topNote"
					:note="props.bookFlight?.general?.note"
					:searchFlightCTAText="props.bookFlight?.general?.searchFlightCTAText"
					:ondSelection="props.bookFlight?.ondSelection"
					:additionalONDFilter="props.bookFlight?.general?.ondFilter"
					:datePicker="props.bookFlight?.datePicker"
					:promoCodeLabel="props.bookFlight?.promoCode?.promoCodeLabel"
					:promoCodePlaceholder="props.bookFlight?.promoCode?.promoCodePlaceholder"
					:promoCode="promoCode"
					:promoCodeLabelPH="props.bookFlight?.promoCode?.promoCodeLabelPH"
					:promoCodeErrorMessage="props.bookFlight?.promoCode?.promoCodeErrorMessage"
					:supersedePromoCode="props.bookFlight?.promoCode?.supersedePromoCode?.trim()"
					:supersedeOfficeIdSuffix="props.bookFlight?.officeIdSection?.supersedeOfficeIdSuffix?.trim()"
					:passengerSelection="props.bookFlight?.passengerSelection"
					:bstNoteTop="props.bonusSideTrip?.bstPage?.bstNoteTop"
					:bstNoteCTAText="props.bonusSideTrip?.bstPage?.bstNoteCTAText"
					:bstNoteCTAURL="props.bonusSideTrip?.bstPage?.bstNoteCTAURL"
					:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
					:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
					:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
					:flightSearchApiUrl="props.flightSearchApiUrl"
					:cabinClassCashList="props.cabinClassCashList"
					:cabinClassMilesList="props.cabinClassMilesList"
					:togglePointsApiURL="props.togglePointsApiURL"
					:enableMattaToggleButton="props.labels?.mattaFair?.enableMattaToggleButton"
					:mattaToggleButtonLabel="props.labels?.mattaFair?.mattaToggleButtonLabel"
					:hidePromoCodeField="props.bookFlight?.promoCode?.hidePromoCodeField"
					:enrichAlwaysOn="props.bookFlight?.enrichAlwaysOn?.enableFunctionality"
					:autoApplyEnrichAlwaysOn="props.bookFlight?.enrichAlwaysOn?.autoApplyEnrichAlwaysOn"
					:enablePostMattaCampaign="props.bookFlight?.enrichAlwaysOn?.enablePostMattaCampaign"
					:nonLoggedInMessageNote="props.bookFlight?.enrichAlwaysOn?.nonLoggedInMessageNote"
					:loggedInMessageNote="props.bookFlight?.enrichAlwaysOn?.loggedInMessageNote"
					:enrichAlwaysOnCountriesData="props.enrichAlwaysOnCountriesData"
					:disableGeolocation="props.labels?.nearYou?.disableGeolocation"
					:enableONDLocaleTranslation="props.labels?.ondLocale?.isEnableLocale"
					:countryVariants="props.countryVariants"
					:expressBooking="props.bookFlight?.expressBooking"
					:signUpApiUrl="props.signUpApiUrl"
					:dspbookingEnable="props.dspBookingRedirector.dspbookingEnable"
					:enableDSPBookingRedirector="props.dspBookingRedirector.enableDSPBookingRedirector"
					:dspBookingApiUrl="props.dspBookingApiUrl"
					:enableGlassDesign="props.bookFlight?.general?.enableGlassDesign"
					:expressBookingSelected="expressBooking"
					@save-search-data="handleSaveSearchData({ isBSTTab: false, ...$event })"
					@show-bst-overlay="handleShowBSTOverlay"
					@form-submission="sendFormCompleteAA('book-flight', $event)"
					@express-booking-status="handleExpressBookingStatus"
					@express-booking-disabled="handleExpressBookingDisabled"
					@on:trigger="triggerFlightStartEvent"
					@ond-selected="isONDSelected = $event?.selected"
				></SubTabBookFlight>
			</div>
			<div
				v-if="!props.multiCity?.general?.isHideInDesktop"
				identifier="multi-city"
			>
				<SubTabMultiCity
					class="pt-6"
					:subHeaderTabDescription="props.multiCity?.general?.subHeaderTabDescription"
					:subHeaderTabTooltipBody="props.multiCity?.general?.subHeaderTabTooltipBody"
					:subHeaderTabTooltipLabel="props.multiCity?.general?.subHeaderTabTooltipLabel"
					:note="props.multiCity?.general?.note"
					:removeCTAText="props.multiCity?.general?.removeCTAText"
					:addAnotherFlightCTAText="props.multiCity?.general?.addAnotherFlightCTAText"
					:searchFlightCTAText="props.multiCity?.general?.searchFlightCTAText"
					:ondSelection="props.multiCity?.ondSelection"
					:datePicker="props.multiCity?.datePicker"
					:passengerSelection="props.multiCity?.passengerSelection"
					:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
					:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
					:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
					:flightSearchApiUrl="props.flightSearchApiUrl"
					:cabinClassCashList="props.cabinClassCashList"
					:enableONDLocaleTranslation="props.labels?.ondLocale?.isEnableLocale"
					:promoCode="props.multiCity?.promoCode"
					:countryVariants="props.countryVariants"
					:enableGlassDesign="props.multiCity?.general?.enableGlassDesign"
					:continueYourSearchLabel="props.bookFlight?.continueYourSearch?.continueYourSearchLabel"
					:economyLabel="props.bookFlight?.passengerSelection?.economyLabel"
					:businessLabel="props.bookFlight?.passengerSelection?.businessLabel"
					:businessSuiteLabel="props.bookFlight?.passengerSelection?.businessSuiteLabel"
					:isHideContinueYourSearchSection="props.isHideContinueYourSearchSection"
					@restore-past-search="restorePastSearch"
					@on:trigger="triggerFlightStartEvent"
					@form-submission="sendFormCompleteAA('multi-city', $event)"
				></SubTabMultiCity>
			</div>
			<div
				v-if="!props.labels?.flightType?.isHideInDesktopRedeemFlight"
				identifier="redeem-flight"
			>
				<SubTabRedeemFlight
					ref="subTabRedeemFlightEl"
					class="pt-6"
					:payByEnrichPoints="true"
					:hideTodayDateIndicator="props.labels?.paymentType?.hideTodayDateIndicator"
					:owGeneralDetails="props.redeemFlightOW.general"
					:owOndSelection="props.redeemFlightOW?.ondSelection"
					:owDatePicker="props.redeemFlightOW?.datePicker"
					:owPassengerSelection="props.redeemFlightOW?.passengerSelection"
					:owPromoCode="props.redeemFlightOW?.promoCode"
					:owEnrichAlwaysOn="props.redeemFlightOW?.enrichAlwaysOn"
					:mhGeneralDetails="props.redeemFlight?.general"
					:mhOndSelection="props.redeemFlight?.ondSelection"
					:mhDatePicker="props.redeemFlight?.datePicker"
					:mhPassengerSelection="props.redeemFlight?.passengerSelection"
					:mhPromoCode="props.redeemFlight?.promoCode"
					:mhEnrichAlwaysOn="props.redeemFlight?.enrichAlwaysOn"
					:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
					:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
					:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
					:flightSearchApiUrl="props.flightSearchApiUrl"
					:cabinClassCashList="props.cabinClassCashList"
					:cabinClassMilesList="props.cabinClassMilesList"
					:togglePointsApiURL="props.togglePointsApiURL"
					:enableMattaToggleButton="props.labels?.mattaFair?.enableMattaToggleButton"
					:mattaToggleButtonLabel="props.labels?.mattaFair?.mattaToggleButtonLabel"
					:enrichAlwaysOnCountriesData="props.enrichAlwaysOnCountriesData"
					:disableGeolocation="props.labels?.nearYou?.disableGeolocation"
					:enableONDLocaleTranslation="props.labels?.ondLocale?.isEnableLocale"
					:countryVariants="props.countryVariants"
					:cabinClassMilesOWList="props.cabinClassMilesOWList"
					:enableGlassDesign="props.redeemFlight?.general?.enableGlassDesign"
					@save-search-data="handleSaveSearchData({ isBSTTab: false, ...$event })"
					@show-bst-overlay="handleShowBSTOverlay"
					@form-submission="sendFormCompleteAA('redeem-flight', $event)"
				></SubTabRedeemFlight>
			</div>
			<div
				v-if="!props.bonusSideTrip?.general?.isHideInDesktop"
				identifier="bonus-side-trip"
			>
				<SubTabBonusSideTrip
					ref="subTabBonusSideTripEl"
					class="pt-6"
					:subHeaderTabDescription="props.bonusSideTrip?.general?.subHeaderTabDescription"
					:subHeaderTabTooltipBody="props.bonusSideTrip?.general?.subHeaderTabTooltipBody"
					:subHeaderTabTooltipLabel="props.bonusSideTrip?.general?.subHeaderTabTooltipLabel"
					:note="props.bonusSideTrip?.general?.note"
					:searchFlightCTAText="props.bonusSideTrip?.general?.searchFlightCTAText"
					:ondSelection="props.bonusSideTrip?.ondSelection"
					:datePicker="props.bonusSideTrip?.datePicker"
					:passengerSelection="props.bonusSideTrip?.passengerSelection"
					:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
					:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
					:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
					:cabinClassCashList="props.cabinClassCashList"
					:enableONDLocaleTranslation="props.labels?.ondLocale?.isEnableLocale"
					:countryVariants="props.countryVariants"
					:enableGlassDesign="props.bonusSideTrip?.general?.enableGlassDesign"
					@save-search-data="handleSaveSearchData({ isBSTTab: true, ...$event })"
					@show-bst-overlay="handleShowBSTOverlay"
					@form-submission="sendFormCompleteAA('bonus-side-trip')"
				></SubTabBonusSideTrip>
			</div>
			<div v-if="!props.termsAndConditionsTab?.general?.isHideInDesktop && props.termsAndConditionsTab?.showTandCTab" identifier="terms-and-conditions">
				<SubTabTermsConditions :content="props.termsAndConditionsTab?.termsAndConditions" />
			</div>
		</VueTabs>
		<ContinueYourSearch
			v-if="!props.isHideContinueYourSearchSection && !props.labels?.enableGlassDesign"
			ref="continueYourSearchComponent"
			class="continue-your-search-container mt-5"
			:continueYourSearchLabel="props.bookFlight?.continueYourSearch?.continueYourSearchLabel"
			:economyLabel="props.bookFlight?.passengerSelection?.economyLabel"
			:businessLabel="props.bookFlight?.passengerSelection?.businessLabel"
			:businessSuiteLabel="props.bookFlight?.passengerSelection?.businessSuiteLabel"
			@restore-past-search="restorePastSearch"
		></ContinueYourSearch>
		<div
			
			v-if="
				activeSubTab !== 'multi-city' &&
					props.labels?.enableGlassDesign &&
					(
						(isONDSelected) ||
						(!isMobileViewport && (!isSticked || isONDSelected))
					)
			"

			:class="{ 'flex flex-col gap-2 items-center': props.labels?.enableGlassDesign, 'mt-3': props.labels?.enableGlassDesign && !isMobileViewport }"
		>
			<div :class="{ 'glass-design': props.labels?.enableGlassDesign }" class="bottom-wrapper flex flex-row justify-between items-center w-full md:gap-3">
				<div>
					<ContinueYourSearch
						v-if="!props.isHideContinueYourSearchSection"
						ref="continueYourSearchComponent"
						class="continue-your-search-container"
						:continueYourSearchLabel="props.bookFlight?.continueYourSearch?.continueYourSearchLabel"
						:economyLabel="props.bookFlight?.passengerSelection?.economyLabel"
						:businessLabel="props.bookFlight?.passengerSelection?.businessLabel"
						:businessSuiteLabel="props.bookFlight?.passengerSelection?.businessSuiteLabel"
						:enableGlassDesign="props.labels?.enableGlassDesign"
						:nonLoggedInMessage="props.bookFlight?.enrichAlwaysOn?.nonLoggedInMessageNote"
						:promoCodeLength="promoCode?.length || 0"
						:activeSubTab="activeSubTab"
						:isshrunk="isPromoEditorEnabled"
						@is-past-search-empty="handleShowLoginNote"
						@restore-past-search="restorePastSearch"
					></ContinueYourSearch>
				</div>
				<div
					v-if="props.labels?.enableGlassDesign && activeSubTab !== 'redeem-flight' && activeSubTab !== 'bonus-side-trip' && !isMobileViewport"
					:class="{
						'glass-design': props.labels.enableGlassDesign,
					}"
					class="flex items-center end >lg:ml-auto pb-2 >lg:pb-0"
				>
					<div v-if="!props.bookFlight?.promoCode?.hidePromoCodeField">
						<button
							v-if="!isPromoEditorEnabled"
							type="button"
							class="flex items-center p-0 gap-2 promocode-btn pr-2"
							:class="{ 'promocode-bg': promoCode !== null }"
							@click="enablePromocodeEditor(true)"
						>
							<icon-fas-badge-percent class="icon fill-primary-blue-base w-4.5 ml-2 shrink-0" />
							<div class="flex flex-col flex-1 min-w-0 text-left">
								<span v-if="promoCode" class="text-xs leading-tight text-neutral-grey-dark">
									{{ props.bookFlight?.promoCode?.promoCodeLabel }}
								</span>
								<span
									class="text-sm text-primary-blue-base leading-tight truncate promocode-value"
									:class="{ 'promocode-color': promoCode !== null, 'has-value': promoCode }"
								>
									{{ promoCode || props.bookFlight?.promoCode?.promoCodeLabel }}
								</span>
							</div>
							<icon-fas-xmark
								v-if="promoCode"
								class="w-3 fill-neutral-grey-extradark cursor-pointer shrink-0 mr-3"
								@click="resetPromoCode()"
							/>
						</button>

						<div v-else class="flex items-center gap-2 ml-2 promocode-wrapper mr-2">
							<icon-fas-badge-percent class="icon fill-primary-blue-base ml-3 shrink-0" />
							<div class="flex flex-col flex-1 min-w-0">
								<label for="promo-code" class="text-xs leading-tight text-neutral-grey-dark sr-only">
									{{ props.bookFlight?.promoCode?.promoCodeLabel }}
								</label>
								<input
									id="promo-code"
									ref="promoInputRef"
									v-model="promoCode"
									type="text"
									class="promocode-editor flex-1 border-0 outline-none bg-transparent min-w-0"
									@keyup.enter="enablePromocodeEditor(false)"
								/>
							</div>
						</div>
					</div>
					<div
						v-if="props.bookFlight?.expressBooking && props.bookFlight?.expressBooking.turnOnExpressBooking && !isMobileViewport"
						class="flex items-center express-booking-wrapper"
						:class="{ 'disabled': !isExpressBookingDisabled }"
					>
					
						<label class="express-booking-checkbox">
							<input v-model="expressBooking" type="checkbox" />
							<span class="check-mark"></span>
							<span class="check-label text-sm text-primary-blue-base">{{ props.bookFlight?.expressBooking?.expressBookingCheckboxLabel }}</span>
						</label>
					</div>
					<Tooltip
						v-if="props.bookFlight?.expressBooking?.expressBookingTooltipDescription && !isMobileViewport"
						class="inline-flex"
					>
						<template #default>
							<div class="flex items-center">
								<icon-fas-circle-info
									class="icon fill-primary-blue-base w-5 ml-1"
									aria-hidden="true"
								/>
							</div>
						</template>
						<template #tooltip-content>
							<div v-html-sanitize="props.bookFlight?.expressBooking.expressBookingTooltipDescription"></div>
						</template>
					</Tooltip>
				</div>
			</div>
			<div v-if="!isLoggedIn && !isMobileViewport && showLoginNote && !props.enableGlassDesign && activeSubTab !== 'redeem-flight'" class="w-full">
				<div class="login-disclaimer flex justify-between text-xs w-full">
					<span v-html-sanitize="props.bookFlight?.enrichAlwaysOn?.nonLoggedInMessageNote"></span>
				</div>
			</div>
		</div>
	</div>
</div>

<MobileSubpage
	:isVisible="isMobileSubpageVisible && !isEnrichPortal"
	class="text-white"
	style="--overlay-container-bg-color: var(--secondary-blue-extradark);"
	:mobileSubPageDesign="props.labels.enableGlassDesign ? 'glass-design' : 'MH'"
	:enableGlassDesign="props.labels.enableGlassDesign"
	:blendedHeaderCss="blendedHeaderCss"
	:mobileSwiperTabs="props.mobileSwiperTabs"
	@update:is-visible="isMobileSubpageVisible = $event"
>
	<template #banner-title>
		<h1 v-if="!props.labels.enableGlassDesign" class="text-center">{{ $t('Flight Search') }}</h1>
		<h3 v-else class="text-center">{{ $t('Flight Search') }}</h3>
	</template>

	<template #swiper>
		<slot name="banner-title">
			<MobileSubPageSwiper
				:mobileSwiperTabs="props.mobileSwiperTabs.length === 0 ? JSON.parse(mobileProperties) : props.mobileSwiperTabs"
				activeTab="#flight-search"
			/>
		</slot>
	</template>

	<template #default>
		<div class="generic-container mb-20" :class="{ 'mt-4': props.labels?.enableGlassDesign }">
			<VueTabs
				ref="vueTabsComponent"
				v-model="activeSubTab"
				:enableGlassDesign="props.labels?.enableGlassDesign"
				renderPanelsWithVShow
				@update:modelValue="$emit('update:active-sub-tab', $event)"
			>
				<template v-if="!props.bookFlight?.general?.isHideInMobile && props.labels?.flightType?.bookFlightLabel" #tab-book-flight>
					<div class="flex items-center justify-center p-4">
						<span class="inline-block ml-1">{{ props.labels?.flightType?.bookFlightLabel }}</span>
					</div>
				</template>
				<template v-if="!props.multiCity?.general?.isHideInMobile && props.labels?.flightType?.multiCityLabel" #tab-multi-city>
					<div class="flex items-center justify-center p-4">
						<span class="inline-block ml-1">{{ props.labels?.flightType?.multiCityLabel }}</span>
					</div>
				</template>
				<template v-if="!props.labels?.flightType?.isHideInMobileRedeemFlight && props.labels?.flightType?.redeemFlightLabel" #tab-redeem-flight>
					<div class="flex items-center justify-center p-4">
						<span class="inline-block ml-1">{{ props.labels?.flightType?.redeemFlightLabel }}</span>
					</div>
				</template>
				<template v-if="!props.labels?.flightType?.isHideInMobile && props.labels?.flightType?.roundTheWorldLabel" #link-round-the-world>
					<AppHyperlink
						v-aa="[
							{
								clickName: props.labels?.flightType?.roundTheWorldLabel,
								clickComponentType: 'Button',
								componentName: 'FlightSearch',
								componentID: props.componentIdAA,
							},
							{
								name: props.labels?.flightType?.roundTheWorldLabel,
								type: isUrlMatchCurrentHostname(props.labels?.flightType?.roundTheWorldURL) ? 'other' : 'exit',
							},
						]"
						:href="props.labels?.flightType?.roundTheWorldURL"
						class="font-semibold text-$text-color rounded-xl px-4 hover:bg-neutral-grey-extralight h-full leading-none"
						:target="props.labels?.flightType?.openInNewTab ? '_blank' : '_self'"
						:autoExternalLinkIcon="true"
					>{{ props.labels?.flightType?.roundTheWorldLabel }}</AppHyperlink>
				</template>
				<template v-if="!props.bonusSideTrip?.general?.isHideInMobile && props.labels?.flightType?.bonusSideTripLabel" #tab-bonus-side-trip>
					<div class="flex items-center justify-center p-4">
						<span class="inline-block ml-1">{{ props.labels?.flightType?.bonusSideTripLabel }}</span>
					</div>
				</template>
				<template v-if="!props.termsAndConditionsTab?.general?.isHideInMobile && props.termsAndConditionsTab?.showTandCTab" #tab-terms-and-conditions>
					<div class="flex items-center justify-center p-4">
						<span class="inline-block ml-1">{{ props.termsAndConditionsTab?.termsAndConditionsLabel }}</span>
					</div>
				</template>

				<div
					v-if="!props.bookFlight?.general?.isHideInMobile"
					identifier="book-flight"
				>
					<div
						v-if="props.bookFlight?.general?.enableGlassDesign
							&& activeSubTab !== 'redeem-flight'
							&& isONDSelected"
						:class="{
							'glass-design flex': props.labels.enableGlassDesign,
						}"
						class="mt-3"
					>
						<div
							v-if="props.bookFlight?.expressBooking && props.bookFlight?.expressBooking.turnOnExpressBooking"
							class="flex items-center express-booking-wrapper"
							:class="{ 'disabled': !isExpressBookingDisabled }"
						>
						
							<label class="express-booking-checkbox">
								<input v-model="subPageMblExpressBooking" type="checkbox" />
								<span class="check-mark"></span>
								<span class="check-label text-sm text-primary-blue-base">{{ props.bookFlight?.expressBooking?.expressBookingCheckboxLabel }}</span>
							</label>
						</div>
						<Tooltip
							v-if="props.bookFlight?.expressBooking?.expressBookingTooltipDescription"
							class="inline-flex"
						>
							<template #default>
								<div class="flex items-center">
									<icon-fas-circle-info
										class="icon fill-primary-blue-base w-5 ml-1"
										aria-hidden="true"
									/>
								</div>
							</template>
							<template #tooltip-content>
								<div v-html-sanitize="props.bookFlight?.expressBooking.expressBookingTooltipDescription"></div>
							</template>
						</Tooltip>
					</div>
					<SubTabBookFlight
						ref="subTabBookFlightEl"
						class="pt-6"
						:hideTodayDateIndicator="props.labels?.paymentType?.hideTodayDateIndicator"
						:subHeaderTabDescription="props.bookFlight?.general?.subHeaderTabDescription"
						:subHeaderTabTooltipBody="props.bookFlight?.general?.subHeaderTabTooltipBody"
						:subHeaderTabTooltipLabel="props.bookFlight?.general?.subHeaderTabTooltipLabel"
						:topNote="props.bookFlight?.general?.topNote"
						:note="props.bookFlight?.general?.note"
						:searchFlightCTAText="props.bookFlight?.general?.searchFlightCTAText"
						:ondSelection="props.bookFlight?.ondSelection"
						:additionalONDFilter="props.bookFlight?.general?.ondFilter"
						:datePicker="props.bookFlight?.datePicker"
						:promoCodeLabel="props.bookFlight?.promoCode?.promoCodeLabel"
						:promoCodeErrorMessage="props.bookFlight?.promoCode?.promoCodeErrorMessage"
						:supersedePromoCode="props.bookFlight?.promoCode?.supersedePromoCode?.trim()"
						:supersedeOfficeIdSuffix="props.bookFlight?.officeIdSection?.supersedeOfficeIdSuffix?.trim()"
						:passengerSelection="props.bookFlight?.passengerSelection"
						:bstNoteTop="props.bonusSideTrip?.bstPage?.bstNoteTop"
						:bstNoteCTAText="props.bonusSideTrip?.bstPage?.bstNoteCTAText"
						:bstNoteCTAURL="props.bonusSideTrip?.bstPage?.bstNoteCTAURL"
						:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
						:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
						:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
						:datePickerQuestionMobile="props.mobileAddOns?.datePickerQuestionMobile"
						:passengerSelectionQuestion="props.mobileAddOns?.passengerSelectionQuestion"
						:flightSearchApiUrl="props.flightSearchApiUrl"
						:cabinClassCashList="props.cabinClassCashList"
						:cabinClassMilesList="props.cabinClassMilesList"
						:togglePointsApiURL="props.togglePointsApiURL"
						:enableMattaToggleButton="props.labels?.mattaFair?.enableMattaToggleButton"
						:mattaToggleButtonLabel="props.labels?.mattaFair?.mattaToggleButtonLabel"
						:hidePromoCodeField="props.bookFlight?.promoCode?.hidePromoCodeField"
						:enrichAlwaysOn="props.bookFlight?.enrichAlwaysOn?.enableFunctionality"
						:autoApplyEnrichAlwaysOn="props.bookFlight?.enrichAlwaysOn?.autoApplyEnrichAlwaysOn"
						:enablePostMattaCampaign="props.bookFlight?.enrichAlwaysOn?.enablePostMattaCampaign"
						:nonLoggedInMessageNote="props.bookFlight?.enrichAlwaysOn?.nonLoggedInMessageNote"
						:loggedInMessageNote="props.bookFlight?.enrichAlwaysOn?.loggedInMessageNote"
						:enrichAlwaysOnCountriesData="props.enrichAlwaysOnCountriesData"
						:disableGeolocation="props.labels?.nearYou?.disableGeolocation"
						:disableCalendarPickerAnimation="true"
						:countryVariants="props.countryVariants"
						:expressBooking="props.bookFlight?.expressBooking"
						:signUpApiUrl="props.signUpApiUrl"
						:dspbookingEnable="props.dspBookingRedirector.dspbookingEnable"
						:enableDSPBookingRedirector="props.dspBookingRedirector.enableDSPBookingRedirector"
						:dspBookingApiUrl="props.dspBookingApiUrl"
						:enableGlassDesign="props.bookFlight?.general?.enableGlassDesign"
						:mblExpressBookingSelected="subPageMblExpressBooking"
						:promoCode="promoCode"
						@express-booking-status="handleExpressBookingStatus"
						@express-booking-disabled="handleExpressBookingDisabled"
						@save-search-data="handleSaveSearchData({ isBSTTab: false, ...$event })"
						@show-bst-overlay="handleShowBSTOverlay"
						@form-submission="sendFormCompleteAA('book-flight', $event)"
						@on:trigger="triggerFlightStartEvent"
						@ond-selected="isONDSelected = $event?.selected"
					></SubTabBookFlight>

					<div
						v-if="props.bookFlight?.general?.enableGlassDesign && bookingWidgetSubPageVisible"
						:class="{ 'glass-design': props.labels?.enableGlassDesign }"
						class="mt-3"
					>
						<div>
							<ContinueYourSearch
								v-if="!props.isHideContinueYourSearchSection"
								ref="continueYourSearchComponent"
								class="continue-your-search-container"
								:continueYourSearchLabel="props.bookFlight?.continueYourSearch?.continueYourSearchLabel"
								:economyLabel="props.bookFlight?.passengerSelection?.economyLabel"
								:businessLabel="props.bookFlight?.passengerSelection?.businessLabel"
								:businessSuiteLabel="props.bookFlight?.passengerSelection?.businessSuiteLabel"
								:enableGlassDesign="props.labels?.enableGlassDesign"
								:nonLoggedInMessage="props.bookFlight?.enrichAlwaysOn?.nonLoggedInMessageNote"
								:activeSubTab="activeSubTab"
								@is-past-search-empty="handleShowLoginNote"
								@restore-past-search="restorePastSearch"
							></ContinueYourSearch>
						</div>
					</div>
				</div>
				<div
					v-if="!props.multiCity?.general?.isHideInMobile"
					identifier="multi-city"
				>
					<SubTabMultiCity
						class="pt-6"
						:subHeaderTabDescription="props.multiCity?.general?.subHeaderTabDescription"
						:subHeaderTabTooltipBody="props.multiCity?.general?.subHeaderTabTooltipBody"
						:subHeaderTabTooltipLabel="props.multiCity?.general?.subHeaderTabTooltipLabel"
						:note="props.multiCity?.general?.note"
						:removeCTAText="props.multiCity?.general?.removeCTAText"
						:addAnotherFlightCTAText="props.multiCity?.general?.addAnotherFlightCTAText"
						:searchFlightCTAText="props.multiCity?.general?.searchFlightCTAText"
						:ondSelection="props.multiCity?.ondSelection"
						:datePicker="props.multiCity?.datePicker"
						:passengerSelection="props.multiCity?.passengerSelection"
						:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
						:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
						:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
						:datePickerQuestionMobile="props.mobileAddOns?.datePickerQuestionMobile"
						:passengerSelectionQuestion="props.mobileAddOns?.passengerSelectionQuestion"
						:flightSearchApiUrl="props.flightSearchApiUrl"
						:cabinClassCashList="props.cabinClassCashList"
						:promoCode="props.multiCity?.promoCode"
						:countryVariants="props.countryVariants"
						:enableGlassDesign="props.multiCity?.general?.enableGlassDesign"
						@on:trigger="triggerFlightStartEvent"
						@form-submission="sendFormCompleteAA('multi-city', $event)"
					></SubTabMultiCity>
				</div>

				<div
					v-if="!props.labels?.flightType?.isHideInMobileRedeemFlight"
					identifier="redeem-flight"
				>
					<SubTabRedeemFlight
						ref="subTabRedeemFlightEl"
						class="pt-6"
						:payByEnrichPoints="true"
						:hideTodayDateIndicator="props.labels?.paymentType?.hideTodayDateIndicator"
						:owGeneralDetails="props.redeemFlightOW.general"
						:owOndSelection="props.redeemFlightOW?.ondSelection"
						:owDatePicker="props.redeemFlightOW?.datePicker"
						:owPassengerSelection="props.redeemFlightOW?.passengerSelection"
						:owPromoCode="props.redeemFlightOW?.promoCode"
						:owEnrichAlwaysOn="props.redeemFlightOW?.enrichAlwaysOn"
						:mhGeneralDetails="props.redeemFlight?.general"
						:mhOndSelection="props.redeemFlight?.ondSelection"
						:mhDatePicker="props.redeemFlight?.datePicker"
						:mhPassengerSelection="props.redeemFlight?.passengerSelection"
						:mhPromoCode="props.redeemFlight?.promoCode"
						:mhEnrichAlwaysOn="props.redeemFlight?.enrichAlwaysOn"
						:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
						:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
						:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
						:flightSearchApiUrl="props.flightSearchApiUrl"
						:cabinClassCashList="props.cabinClassCashList"
						:cabinClassMilesList="props.cabinClassMilesList"
						:togglePointsApiURL="props.togglePointsApiURL"
						:enableMattaToggleButton="props.labels?.mattaFair?.enableMattaToggleButton"
						:mattaToggleButtonLabel="props.labels?.mattaFair?.mattaToggleButtonLabel"
						:enrichAlwaysOnCountriesData="props.enrichAlwaysOnCountriesData"
						:disableGeolocation="props.labels?.nearYou?.disableGeolocation"
						:enableONDLocaleTranslation="props.labels?.ondLocale?.isEnableLocale"
						:countryVariants="props.countryVariants"
						:cabinClassMilesOWList="props.cabinClassMilesOWList"
						:enableGlassDesign="props.redeemFlight?.general?.enableGlassDesign"
						@save-search-data="handleSaveSearchData({ isBSTTab: false, ...$event })"
						@show-bst-overlay="handleShowBSTOverlay"
						@form-submission="sendFormCompleteAA('redeem-flight', $event)"
					></SubTabRedeemFlight>
				</div>
				
				<div
					v-if="!props.bonusSideTrip?.general?.isHideInMobile"
					identifier="bonus-side-trip"
				>
					<SubTabBonusSideTrip
						ref="subTabBonusSideTripEl"
						class="pt-6"
						:subHeaderTabDescription="props.bonusSideTrip?.general?.subHeaderTabDescription"
						:subHeaderTabTooltipBody="props.bonusSideTrip?.general?.subHeaderTabTooltipBody"
						:subHeaderTabTooltipLabel="props.bonusSideTrip?.general?.subHeaderTabTooltipLabel"
						:note="props.bonusSideTrip?.general?.note"
						:searchFlightCTAText="props.bonusSideTrip?.general?.searchFlightCTAText"
						:ondSelection="props.bonusSideTrip?.ondSelection"
						:datePicker="props.bonusSideTrip?.datePicker"
						:passengerSelection="props.bonusSideTrip?.passengerSelection"
						:subHeaderTooltipCTATextMobileLabel="props.mobileAddOns?.subHeaderTooltipCTATextMobileLabel"
						:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
						:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
						:datePickerQuestionMobile="props.mobileAddOns?.datePickerQuestionMobile"
						:passengerSelectionQuestion="props.mobileAddOns?.passengerSelectionQuestion"
						:cabinClassCashList="props.cabinClassCashList"
						:countryVariants="props.countryVariants"
						:enableGlassDesign="props.bonusSideTrip?.general?.enableGlassDesign"
						@save-search-data="handleSaveSearchData({ isBSTTab: true, ...$event })"
						@show-bst-overlay="handleShowBSTOverlay"
						@form-submission="sendFormCompleteAA('bonus-side-trip')"
					></SubTabBonusSideTrip>
				</div>
				<div v-if="!props.termsAndConditionsTab?.general?.isHideInMobile && props.termsAndConditionsTab?.showTandCTab" identifier="terms-and-conditions">
					<SubTabTermsConditions :content="props.termsAndConditionsTab?.termsAndConditions" />
				</div>
			</VueTabs>
		</div>

		<Teleport v-if="isLoading" to="body">
			<div
				class="generic-backdrop flight-search-bg !bg-white/80"
			>
				<div class="flex items-center justify-center h-full w-full">
					<AppSpinner />
				</div>
			</div>
		</Teleport>
	</template>

</MobileSubpage>


<OverlayBonusSideTrip
	:isVisible="isBSTOverlayVisible"
	:bstNoteTop="props.bonusSideTrip?.bstPage?.bstNoteTop"
	:bstNoteCTAText="props.bonusSideTrip?.bstPage?.bstNoteCTAText"
	:bstNoteCTAURL="props.bonusSideTrip?.bstPage?.bstNoteCTAURL"
	:bstEditSearchCTAText="props.bonusSideTrip?.bstPage?.bstEditSearchCTAText"
	:bstLabel="props.bonusSideTrip?.bstPage?.bstLabel"
	:optionLabel="props.bonusSideTrip?.bstPage?.optionLabel"
	:visitMalaysiaLabel="props.bonusSideTrip?.bstPage?.visitMalaysiaLabel"
	:yourDateOfChoiceLabel="props.bonusSideTrip?.bstPage?.yourDateOfChoiceLabel"
	:question1Text="props.bonusSideTrip?.bstPage?.question1Text"
	:question2Text="props.bonusSideTrip?.bstPage?.question2Text"
	:continueWithoutBSTCTAText="props.bonusSideTrip?.bstPage?.continueWithoutBSTCTAText"
	:continueCTAText="props.bonusSideTrip?.bstPage?.continueCTAText"
	:toLabel="props.bonusSideTrip?.bstPage?.toLabel"
	:departLabel="props.bonusSideTrip?.bstPage?.departLabel"
	:bstQuestion1MobileLabel="props.mobileAddOns?.bstQuestion1MobileLabel"
	:bstQuestion2MobileLabel="props.mobileAddOns?.bstQuestion2MobileLabel"
	:bstDisabledContinueCtaLabel="props.bonusSideTrip?.bstPage?.disabledContinueCtaLabel"

	:ondSelection="props.bonusSideTrip?.ondSelection"
	:datePicker="props.bonusSideTrip?.datePicker"
	:passengerSelection="props.bonusSideTrip?.passengerSelection"
	:fromQuestionMobile="props.mobileAddOns?.fromQuestionMobile"
	:toQuestionMobile="props.mobileAddOns?.toQuestionMobile"
	:datePickerQuestionMobile="props.mobileAddOns?.datePickerQuestionMobile"
	:passengerSelectionQuestion="props.mobileAddOns?.passengerSelectionQuestion"

	:cabinClassCashList="props.cabinClassCashList"
	:cabinClassMilesList="props.cabinClassMilesList"

	:flightSearchApiUrl="props.flightSearchApiUrl"
	:bstAssetType="props.bonusSideTrip.bstPage?.assetType"
	:bstAssetPath="props.bonusSideTrip.bstPage?.assetPath"
	:reviewYourTripLabel="props.bonusSideTrip.bstPage?.reviewYourTripLabel"
	:bonusSideTripLabel="props.bonusSideTrip.bstPage?.bonusSideTripLabel"
	:freeJustPayTaxesLabel="props.bonusSideTrip.bstPage?.freeJustPayTaxesLabel"
	:visitAnotherCityText="props.bonusSideTrip.bstPage?.visitAnotherCityText"
	:enableGlassDesign="props.bonusSideTrip?.general?.enableGlassDesign"
	:enableBSTNewDesign="props.bonusSideTrip.bstPage?.enableBSTNewDesign"
	:componentIdAA="props.componentIdAA"
	:extraONDFilterForFlightSearch="{
		additionalONDFilter: props.bookFlight?.general?.ondFilter,
		ondSelection: props.bookFlight?.ondSelection,
	}"

	@update:is-visible="isBSTOverlayVisible = $event"
></OverlayBonusSideTrip>
</template>



<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.FlightSearch {

	:deep(.login-disclaimer) {
		background-color: #EBDFCF;
		border-radius: 16px;
		padding: 8px;
		font-size: 14px;
		font-weight: 300;
	}

	:deep(.express-booking-checkbox) {
		display: inline-flex;
		align-items: center;
		cursor: pointer;
		font-size: 14px;

		input {
			display: none;
		}

		.check-mark {
			width: 16px;
			height: 16px;
			border: 2px solid var(--primary-blue-base);
			border-radius: 50%;
			position: relative;
			margin-right: 4px;
			margin-top: 2px;
		}
		
		input:checked + .check-mark::after {
			content: "";
			width: 7px;
			height: 7px;
			background-color: var(--primary-blue-base);
			border-radius: 50%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	:deep(.bottom-wrapper) {

		.btn-tooltip-trigger {
			padding-left: 0;
			padding-right: 0;
		}
		.glass-design {
			
			.btn-tooltip-trigger {
				
				svg {
					width: 21px;
					height: 21px;
				}
				
				@media #{var.$query-max-lg} {
					display: none;
				}
			}
		}

		&.glass-design {
			@media #{var.$query-max-lg} {
				flex-direction: row !important;
			}
		}

		@media #{var.$query-max-lg} {
			flex-direction: column-reverse;
			
			:deep(button svg) {
				width: 20px !important;
			}
		}
	}

	:deep(.express-booking-wrapper) {

		&.disabled {
			pointer-events: none;
			opacity: 0.5;
		}
	}
	.promocode-wrapper {
		border: 1px solid var(--secondary-gold-base);
		border-radius: 25px;
		padding: 6px 0px 6px 0px;
		max-width: 180px;

		svg {
			width: 21px;
			height: 21px;
		}
	}

	.promocode-editor {
		padding: 2px;
		line-height: normal;
		padding-right: 15px;

		&:focus,
		&:focus-visible {
			outline: none;
			box-shadow: none;
		}
	}

	.promocode-btn {
		max-width: 180px;
		width: auto;
		text-overflow: ellipsis;
		overflow: hidden;

		svg {
			width: 21px;
			height: 21px;
		}

		&.promocode-bg {
			background: #f8f8f8;
			padding: 7px 12px;
			border-radius: 25px;
		}

		span {
			&.promocode-color {
				color: var(--neutral-grey-extradark);
				font-weight: 400;
			}
		}
	}

	.promocode-value {
		
		&.has-value {
			border-bottom: 2px solid var(--neutral-grey-base);
		}
	}

	.reset-promo-btn {
		z-index: 100;
	}

}

</style>